/**
 *
 * Asynchronously loads the component for Com003
 * Author: Truongtx
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./index'));
